module.exports = __webpack_public_path__ + "static/img/bg-id.c78603a6.png";